// Pure decision logic shared by the "step back a page after a mutation
// empties it" fix in FormContainerWithList's CLIENT_OBJECTIVES delete flow.
// Extracted (mirroring formContainerListSelection.ts) so the rule -- decide
// whether the page just emptied by a delete needs to step back one page --
// can be unit tested without mounting the rest of that 3000+ line component.
export function resolveStepBackPageIndex(
  remainingOnPageCount: number,
  pageIndex: number,
): number | null {
  if (remainingOnPageCount === 0 && pageIndex > 0) {
    return pageIndex - 1;
  }
  return null;
}
